define('LNRS/Track/GoalsManager',["jquery"], function ($) {

    function GoalsManager() {
        var currentPageId = $("body").attr("data-page-id");
        var currentLanguageName = $("body").attr("data-page-language-name");
        var currentVersion = $("body").attr("data-page-version");

        this.triggerGoal = function triggerGoal(event) {

            var params = {};
            params['goalId'] = '';
            params['pageId'] = currentPageId;
            params['languageName'] = currentLanguageName;
            params['currentVersion'] = currentVersion;
            params['pageUrl'] = window.location.href;

            if (event.event_name === 'flyout impression') {
                if (event.flyout_class.indexOf("score-industry-section-menu") >= 0) {
                    params['goalId'] = '{A5D85F45-35E0-4EC3-95BC-4B798D03752F}';
                }
            }
            else if (event.event_name === 'contact us') {
                if (event.form_name === 'Media Asset Form') {
                    params['goalId'] = '{80C85728-DBAA-4019-A424-5CCF91B11957}';
                } else {
                    params['goalId'] = '{75D6C27C-676C-45A3-9A1E-66D939F3D525}';
                }
            } else if (event.event_name === 'download') {
                $.post("/TriggerDownloadEvent", { url: event.download_url, pageId: currentPageId, languageName: currentLanguageName, currentVersion: currentVersion, pageUrl: window.location.href });
                params['goalId'] = '{56661F4C-ACC8-4936-B68D-3F3DF35AD4D5}';
            }

            if (params['goalId'] !== '') {
                $.post("/TriggerGoal", params, function () { });
            }
        };

        this.triggerSiteSearch = function(query) {
            $.post("/TriggerSiteSearch", { query: query, pageId: currentPageId, languageName: currentLanguageName, currentVersion: currentVersion, pageUrl: window.location.href }, function () { });
        }
    }

    return new GoalsManager();
});
